module.exports = __webpack_public_path__ + "img/studying_2.d49782e2.svg";